import styled, { css } from 'styled-components';
export const ContentContainer = styled.div`
display: flex;
flex-direction: column;
align-items: flex-start;
align-self: stretch;
background: var(--Neutral-White, #FEFEFE);
width: 100%;
height: auto;
overflow-y: scroll;
height: calc(100vh - 61.5px);
margin-top: 45.5px;
@media (min-width: 768px) {
    height: calc(100vh - 169px);
    margin-top: 54px;
}
&::-webkit-scrollbar, & .hide-overflow-scrollbar::-webkit-scrollbar {
    width: 0px!important;
}

& .text-orange {
    color: var(--Primary-Red-Orange-1, #FB2F2F);
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 150% */
}

@media (min-width: 768px) {
    max-width: 720px;
    margin: 0 auto;
    background: unset;

    & form {
        background: #fff;
    }

}

@media (min-width: 992px) {
    max-width: 894px;
}

&.landing-page {
    form {
        width: 100%;
    }
}
`

export const SettingsMenuContainer = styled.div`
display: flex;
padding: 16px;
flex-direction: column;
align-items: flex-start;
width: 100%;
&.border-bottom-mobile {
   border-bottom: 1px solid #DFDFDF;
}
@media (min-width: 768px) {
    gap: 16px;
    &.border-bottom-mobile {
        border-bottom: none;
    }
}
`

export const SettingsMenuRow = styled.div`
display: flex;
padding: 12px;
align-items: flex-start;
gap: 16px;
width: 100%;
border-radius: 4px;
cursor: pointer;
&.active, &:hover, &:focus {
    background: var(--Primary-Light-Alabaster-1, #F5F5F5);
   
}

&:hover {
    .icon-wrapper-rounded {
        background: var(--Secondary-Light-Grey-1, #DFDFDF);
    }
}

@media (min-width: 768px) {
    background: var(--Neutral-White, #FEFEFE);
    &.active, &:hover, &:focus {
        background: var(--Neutral-White, #FEFEFE);
        box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.10);
    } 
}

`
export const SettingsMenuRowWrapper = styled.div`
display: flex;
flex-direction: column;
align-items: flex-start;
gap: 12px;
flex: 1;
`
export const SettingsMenuRowItem = styled.div`
display: flex;
align-items: center;
gap: 16px;
align-self: stretch;
& p {
    flex: 1 0 0;
    color: var(--Secondary-Dark-Grey-1, #4B4F5E);

    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 150% */
}
`

export const SettingsMenuRowHeader = styled.p`
display: flex;
height: 40px;
flex-direction: column;
justify-content: center;
align-self: stretch;
color: var(--Secondary-Dark-Grey-1, #4B4F5E);
font-size: 16px;
font-style: normal;
font-weight: 600;
line-height: 24px; /* 150% */
`

/**GENERAL */

export const SettingsFormGroup = styled.div`
display: flex;
padding: 16px;
flex-direction: column;
align-items: flex-start;
gap: 24px;
width: 100%;
& p {
    color: var(--Secondary-Smokey-Grey-1, #6B7270);
font-family: Inter;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 24px; /* 150% */
}

@media (min-width: 768px) {
	flex-direction: row;
	flex-wrap: wrap;
}

& div [class^="listselect__ItemComponent"] {
    @media (max-width: 768px) {
        .flex-line.centered,
        .flex-l-r-center {
            flex-direction: column;
            align-items:start;
        }
    }
}
`
export const FlexWrapper = styled.div`
    display: flex;
    width: 100%;
    gap: 8px;
`
export const SettingsFormGroupInput = styled.div<{ error?: any }>`
display: flex;
width: 100%;
flex-direction: column;
align-items: flex-start;
gap: 4px;
@media (min-width: 768px) {
	flex: 50%;

    &.flex-half {
        flex: 0 0 calc(50% - 12px);
    }

	&.flex-full {
		flex: 100%;
	}

    &.cookie-consent-desktop {
        flex-direction: row;
        flex-wrap: wrap;

        & .cookie-consent-label {
            flex: 0 0 100%;
        }

        & .cookie-consent-color {
            flex: 0 0 calc(50% - 1rem);
        }

        & div:nth-child(2) {
            margin-right: 1rem;
        }
    }

}

   & div[class^="group__FormGroupComponent"]  button {
    height: 48px;
   }
@media (max-width: 768px) {
    & div[class^="group__FormGroupComponent"]  {
        input {
            width: 100% !important;
        }
    }

    & div[class^="tooltip__TooltipWrapper"] {
        button {
            height: 48px;
        }
    }

    &.table-overflow-x {
       div[class^="opening_hours_v2__Wrapper"] {
            overflow-x: auto;
            width: 100%;
       }

       div[class^="opening_hours_v2__AddTimeSlotButtonStyle"] {
            min-width: auto;
       }

       table select {
            width: 84px;
       }
    }
}

& .desc {
    color: var(--Secondary-Smokey-Grey-1, #6B7270);
font-family: Inter;
font-size: 12px;
font-style: normal;
font-weight: 500;
line-height: 16px; /* 133.333% */
}
& div[class^="inputgroup__InputGroupComponent"] {
    width: 100%;
    & input,
    & div[class^="inputgroup__InputGroupIcon"] {
        height: 52px;
    }
}

${props => props.error ? `

    & div[class^="settings-v2__SettingsFormLabelContainer"],
    & div[class^="settings-v2__SettingsFormInputContainer"] {
        border-color: var(--Status-Cancelled, #BC362F);
        color:var(--Status-Cancelled, #BC362F);
        & div[class^="settings-v2__SettingsFormLabelLeftContainer"],
        & input, & textarea {
            color:var(--Status-Cancelled, #BC362F);
        }
        & svg path {
            fill: var(--Status-Cancelled, #BC362F);
        }
    }
    &::after {
        content: "${props.error}";
        display: block;
        width: 100%;
        position: relative;
        color:var(--Status-Cancelled, #BC362F);
        font-size: .75rem;
    }
    

 
`
        : null}

 & div[class^="restauranticonselect__Icon-"] {
    border: none;
 }

 &.desktop-only {
    @media (max-width: 767px) {
        display: none;
    }
 }

 &.logo-select {
    & div[class*="selectadv__Wrapper"] {
        flex-wrap: wrap;

        & div[class*="selectadv__WrapperInner"] {
            flex: calc(100% - 36px);
        }

        & div[class*="selectadv__Dropdown"] {
            position: relative;
        }
    }
 }

`

export const SettingsFormLabelContainer = styled.div`
display: flex;
align-items: center;
gap: 8px;
align-self: stretch;
&.desktop-only {
    width: 100%;
    @media (max-width: 768px) {
        display: none;
    }
    & button {
        align-self: stretch;
        padding-left: 32px;
        padding-right:32px;
    }
}
`
export const SettingsFormLabelLeftContainer = styled.div`
display: flex;
align-items: flex-start;
gap: 8px;
flex: 1 0 0;
color: var(--Secondary-Dark-Grey-1, #4B4F5E);
font-size: 16px;
font-family: Inter;
font-style: normal;
font-weight: 600;
line-height: 24px; /* 171.429% */
 @media (max-width: 768px) {
    font-size: 12px;
}
`

export const SettingsFormLabelRightContainer = styled.div`
display: flex;
justify-content: flex-end;
align-items: center;
gap: 8px;
flex: 0 0 20px;
`


export const SettingsFormInputContainer = styled.div`
display: flex;
padding: 12px;
align-items: center;
gap: 8px;
align-self: stretch;
border-radius: 4px;
border: 1px solid var(--Secondary-Light-Grey-1, #DFDFDF);
background: var(--Neutral-White, #FEFEFE);

& input, & select, & textarea {
    color: var(--Secondary-Dark-Grey-1, #4B4F5E);
    pointer-events: auto;
    font-size: 14px;
    font-family: Inter;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
    border: none;
    width: 100%;
    &:focus-visible {
        outline: unset;
    }
}
&.disabled,&:disabled {
    background: var(--Secondary-Light-Grey-1, #DFDFDF);
    & input {
        background: var(--Secondary-Light-Grey-1, #DFDFDF);
    }
}

& div[class^="datepickerinput"] {
    width: 100%;
    & .dropdown {
        width: 100%;
    }
}

& div[class^="selectadv__Wrapper"],
& div[class^="selectservices__Wrapper"] {
    border: none;
    padding: 0px;
    & div[class^="selectadv__InputIcon"],
    & div[class^="selectservices__InputIcon"]  {
        border-left: none;
        color: #4B4F5E;
        justify-content: end;
    }



    & div[class^="inputtags__Tag"] {
        background: #dfdfdf;
        color: var(--Secondary-Dark-Grey-1, #4B4F5E);
font-family: Inter;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 24px; /* 150% */
    }
}

& div[class^="inputtags__Wrapper"] {
    border: none;
    padding: 0px;
}

&#map-input {
    & div[class^="selectasync__Wrapper"] {
        border: none;
        & div[class^="selectasync__InputIcon"] {
            border: none;
            justify-content: end;
        }

        padding: 0;
        & input {
            height: auto;
            margin: 1px;
        }
        
    }
}

& div.no-border-v2 {
	border: none!important;
    margin-top: 0!important;
}

& div[class^="box__Box"] {
    & input {
        border: 1px solid var(--Secondary-Light-Grey-1, #DFDFDF);
    }
}
    @media(max-width: 768px) {
	width: 100%;
 }

 & .bg-white {
    background: #fff!important;
 }
`

export const SettingsCustomOptionsContainer = styled.div`
display: flex;
flex-direction: column;
align-items: flex-start;
gap: 8px;
align-self: stretch;
@media (min-width: 768px) {
    flex-direction: row;
    & > div {
        flex: 1;
    }
}
`

export const SettingsCustomOption = styled.div`
display: flex;
padding: 12px;
align-items: center;
gap: 8px;
align-self: stretch;
color: var(--Secondary-Dark-Grey-1, #4B4F5E);
font-size: 14px;
font-style: normal;
font-weight: 500;
line-height: 24px; /* 171.429% */
border-radius: 4px;
background: var(--Primary-Light-Alabaster-1, #F5F5F5);
cursor: pointer;
&.active, &:hover, &:active {
    border: 1px solid var(--Primary-Red-Orange-1, #FB2F2F);
    background: var(--Primary-Accent-Wisp-Pink-1, #FFF3F3);
    color: #FB2F2F;
    justify-content: space-between;

    & svg path {
        fill : #FB2F2F;
    }
}

& .icon-w-24 {
    & svg {
        width: 24px;
        height: 24px;
    }
}
`

export const SettingsActionButtonContainer = styled.div<{ activeDesignMode?: boolean }>`

@media (min-width: 768px) {
    position: fixed;
    bottom: 0px;
    width: ${props => props.activeDesignMode ? '460px' : 'calc(100% - 60px)'};
    left: 0px;
    margin-left: 60px;
    border-top: 1px solid var(--Secondary-Light-Grey-1, #DFDFDF);
    background: white;
    z-index: 99;
    & div[class^="settings-v2__SettingsActionButtonWrapper"] {
        position: relative;
        max-width: 894px;
        margin: 0 auto;
        border-top: 0px;
        justify-content: end;

        & button {
            min-width:${props => props.activeDesignMode ? '100%' : '148px'};
            flex: 0;
        }
    }

    & .btn-cancel {
        display: block;
        border: 1px solid var(--Secondary-Light-Grey-1, #DFDFDF);
        background: var(--Neutral-Gray, #F1F4F7);
        color: var(--Secondary-Dark-Grey-1, #4B4F5E);
        cursor: pointer;
    }

    &.no-sidebar {
        margin-left: 0;
        width: 100%;
    }
}
`

export const SettingsActionButtonWrapper = styled('div') <{ position?: string, noborder?: boolean, variant?: string, nopadding?: boolean }>`
display: flex;
width: 100%;
padding: ${props => props.nopadding ? '0' : '16px'};
align-items: center;
gap: 8px;
border-top: ${props => props.noborder ? 'none' : '1px solid var(--Secondary-Light-Grey-1, #DFDFDF)'};
background: #FFF;
position: ${props => props.position || 'fixed'};
bottom: 0;
z-index: 99;

& button {
    display: flex;
padding: 12px;
justify-content: center;
align-items: center;
gap: 4px;
flex: 1 0 0;
border-radius: 4px;
background: var(--Primary-Red-Orange-1, #FB2F2F);
color: var(--Neutral-Gray, #F1F4F7);
text-align: center;
font-size: 14px;
font-style: normal;
font-weight: 700;
line-height: 16px;
appearance: none;
border: none;
min-height: 38px;

${props => props.variant === 'white' ? css`
background: white;
color: #FB2F2F;
border: 1px solid #FB2F2F; 
` : null}
${props => props.variant === 'black' ? css`
background: #4B4F5E;
border-color: #4B4F5E;
background: transparent;
color: #4B4F5E;
` : null}
${props => props.variant === 'default' ? css`
border: 1px solid var(--Secondary-Light-Grey-1, #DFDFDF);
background: var(--Neutral-Gray, #F1F4F7);
color: #4B4F5E;
` : null}

&.default {
    border: 1px solid var(--Secondary-Light-Grey-1, #DFDFDF);
background: var(--Neutral-Gray, #F1F4F7);
color: #4B4F5E;
}

&.btn-cancel {
    border-radius: 4px;
border: 1px solid var(--Secondary-Light-Grey-1, #DFDFDF);
background: var(--Primary-Light-Alabaster-1, #F5F5F5);
color: var(--Secondary-Dark-Grey-1, #4B4F5E);
text-align: center;
font-family: Inter;
font-size: 14px;
font-style: normal;
font-weight: 600;
line-height: 16px;
}
}
@media(min-width: 768px) {
    &.mobile-only {
        display: none;
    }
}

@media(max-width: 768px) {
    &.desktop-only {
        display: none;
    }
}

&.mx-460 {
    max-width: 100%;
    width: 100%;

    @media (min-width: 768px) {
        max-width: 460px;
    }
}

&.mx-420 {
    max-width: 100%;
    left: 0;
    position: fixed;
    @media (min-width: 768px) {
        max-width: 420px;
        left: unset;
        right: 0;
    }
}
`

export const SettingsSwitchContainer = styled.div`
display: flex;
align-items: center;
gap: 24px;
align-self: stretch;
@media (min-width: 768px) {
	flex: 50%;

    &.flex-half {
        flex: 0 0 calc(50% - 12px);
    }

	&.flex-full {
		flex: 100%;
	}
}

& div[class^="Switch__SwitchWrapper"] {
    &:focus, &:active, &:focus-visible {
    background: white!important;
    border-radius: 30px;
    }
}
`

export const SalesTaxesAddButton = styled('button') <{ variant?: string }>`
display: flex;
padding: 8px 16px;
align-items: center;
gap: 4px;
border-radius: 4px;
border: 1px solid var(--Primary-Red-Orange-1, #FB2F2F);
background: transparent;
color: var(--Primary-Red-Orange-1, #FB2F2F);
text-align: center;
font-family: Inter;
font-size: 14px;
font-style: normal;
font-weight: 600;
line-height: 16px; /* 114.286% */
cursor: pointer;
${props => props.variant === 'red' ?
        `background: var(--Primary-Red-Orange-1, #FB2F2F);
 color: var(--Neutral-Gray, #F1F4F7);
 & svg {
    width: 16px;
    height: 16px;
    & path  {
    fill: #f1f4f7;
    }  
}
 `
        : null}
`
export const SalesTaxCard = styled.div`
display: flex;
padding: 12px;
flex-direction: column;
justify-content: center;
align-items: flex-start;
gap: 8px;
align-self: stretch;
border-radius: 4px;
border: 1px dashed var(--Secondary-Light-Grey-1, #DFDFDF);
background: var(--Primary-Light-Alabaster-1, #F5F5F5);
`
export const EligibleItemsContainer = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: flex-start;
align-self: stretch;
& div.no-border-v2 {
	border: none!important;
}

&.menus-v2 {
    justify-content: flex-start;
    padding-bottom: 81px;
    & > div {
        display: flex;
        flex-direction: column;
        width: 100%;
    }
    & div.no-border-v2 .flex-line  {
        padding: 16px;
        border-radius: 4px;
        background: var(--Neutral-Gray, #F1F4F7);

        & label {
            white-space: initial !important;
            max-width: 100%!important;
        }
        & div.m-l-2 {
            margin-left: 16px!important;
        }
    }

    @media (min-width: 768px) {
        padding-bottom: 0px;
    }
}
`
export const EligibleItem = styled.div`
display: flex;
align-items: center;
align-self: stretch;
`
export const EligibleItemIconWrapper = styled.div`
display: flex;
padding: 12px;
align-items: center;
gap: 10px;
`
export const EligibleItemContentWrapper = styled.div`
display: flex;
padding: 12px 12px 12px 0px;
align-items: center;
gap: 8px;
flex: 1 0 0;
color: var(--Secondary-Dark-Grey-1, #4B4F5E);
font-family: Inter;
font-size: 14px;
font-style: normal;
font-weight: 500;
line-height: 24px; /* 171.429% */
`
export const OpeningHoursContainer = styled.div`
display: flex;
padding-bottom: 24px;
padding-top: 16px;
flex-direction: column;
align-items: flex-start;
gap: 16px;
align-self: stretch;

& .width200 {
    width: 100% !important;
}

& button[class^="button__ButtonComponent"] {
    height: 48px!important;
}
`

export const OpeningHoursCard = styled.div`
display: flex;
padding: 12px;
align-items: center;
gap: 16px;
align-self: stretch;
border-radius: 4px;
border: 1px dashed var(--Secondary-Light-Grey-1, #DFDFDF);
background: var(--Primary-Light-Alabaster-1, #F5F5F5);
`
export const OpeningHoursCardWrapper = styled.div`
display: flex;
align-items: center;
gap: 16px;
flex: 1 0 0;
justify-content: space-between;
color: var(--Secondary-Dark-Grey-1, #4B4F5E);
font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px; /* 150% */
`

export const OpeningHoursCardScheduleWrapper = styled.div`
display: flex;
width: 120px;
height: 24px;
justify-content: flex-end;
align-items: center;
gap: 8px;
color: var(--Secondary-Dark-Grey-1, #4B4F5E);
font-family: Inter;
font-size: 14px;
font-style: normal;
font-weight: 500;
line-height: 24px; /* 171.429% */
`

export const OpeningHoursCardDatesWrapper = styled.div`
display: flex;
align-items: center;
gap: 16px;
flex: 1 0 0;
color: var(--Secondary-Dark-Grey-1, #4B4F5E);
font-family: Inter;
font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px; /* 150% */
`

export const MobileModal = styled.div<{ customBackground?: string, isStaff?: boolean, size?: string }>`
display: flex;
width: 100%;
flex-direction: column;
justify-content: flex-end;
align-items: flex-end;
background: ${({ customBackground }) => customBackground ? customBackground : "rgba(28, 28, 28, 0.20)"};
position: fixed;
height: 100%;
z-index: 100;
bottom: 0px;
right: 0;
gap:${({ isStaff }) => isStaff ? '16px' : "0"};
@media (min-width: 768px) {
    left: 0px;
    justify-content: center;

    &.menus-v2 {
        display: none;
    }
}

&.dashboard-filter-modal {
    &.full-mobile {
        & div[class^="settings-v2__MobileModalContent"] {
                max-width: 100%;
                width: 100%;
                margin: 0 0 0 auto;
                height: 100vh;
                justify-content: start;
                border-radius: unset;
                position: relative;
                overflow: auto;
                & div[class^="settings-v2__MobileModalFooter"] {
                    padding-top: 16px;
                    border-top: 1px solid var(--Secondary-Light-Grey-1, #DFDFDF);
                    right: 0px;
                    padding-left: 16px;
                    padding-right: 16px;
                    position: fixed;
                    bottom: 16px;
                    width: 100%;

                    & div[class^="settings-v2__SettingsActionButtonWrapper"] {
                        z-index: 1;
                    }
                }

                & div[class^="settings-v2__SettingsCustomOptionsContainer"] {
                    flex-direction: column;
                }

                @media(min-width: 768px) {
                    max-width: 420px;
                    & div[class^="settings-v2__MobileModalFooter"] {
                        max-width: 420px;
                    }
                }
            }
    }
    @media (min-width: 768px) {
            & div[class^="settings-v2__MobileModalContent"] {
                max-width: 420px;
                width: 100%;
                margin: 0 0 0 auto;
                height: 100vh;
                justify-content: start;
                border-radius: unset;
                position: relative;
                overflow: auto;

                & div[class^="settings-v2__MobileModalFooter"] {
                    padding-top: 16px;
                    border-top: 1px solid var(--Secondary-Light-Grey-1, #DFDFDF);
                    right: 0px;
                    padding-left: 16px;
                    padding-right: 16px;
                    position: fixed;
                    bottom: 16px;
                    width: 420px;

                    & div[class^="settings-v2__SettingsActionButtonWrapper"] {
                        z-index: 1;
                    }
                }

                & div[class^="settings-v2__SettingsCustomOptionsContainer"] {
                    flex-direction: column;
                }

                & .DayPicker {
                    width: 100%;
                }
            }

          
    }
}
`

export const MobileModalContent = styled.div<{ size?: string }>`
display: flex;
padding: 16px;
flex-direction: column;
justify-content: flex-end;
align-items: flex-start;
gap: 16px;
align-self: stretch;
border-radius: 8px 8px 0px 0px;
background: #FFF;
border-top: 1px solid var(--Secondary-Light-Grey-1, #DFDFDF);

@media (min-width: 768px) {
    max-width: 894px;
    width: 100%;
    margin: 0 auto;
    border-radius: 8px;
    ${props => props.size == 'sm' ?
        `max-width: 428px;`
        : null}
}
`

export const MobileModalHeader = styled.div`
display: flex;
align-items: flex-start;
gap: 16px;
align-self: stretch;
justify-content: space-between;
color: var(--Secondary-Dark-Grey-1, #4B4F5E);
font-family: Inter;
font-size: 16px;
font-style: normal;
font-weight: 600;
line-height: 24px; /* 150% */
& svg {
    cursor: pointer;
}
`
export const MobileModalBody = styled.div`
display: flex;
padding: 16px 0px;
flex-direction: column;
align-items: flex-start;
gap: 16px;
align-self: stretch;

& p {
    color: var(--Secondary-Smokey-Grey-1, #6B7270);
font-family: Inter;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 24px; /* 150% */
}
`

export const MobileModalFooter = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
`

export const SettingSwitchWithTextContainer = styled.div<{ error?: any }>`
display: flex;
padding-bottom: 16px;
flex-direction: column;
align-items: flex-start;
gap: 8px;
align-self: stretch;
border-bottom: 1px dashed var(--Secondary-Light-Grey-1, #DFDFDF);
& p {
    display: flex;
align-items: flex-start;
gap: 10px;
align-self: stretch;
color: var(--Secondary-Smokey-Grey-1, #6B7270);
font-family: Inter;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 24px; /* 171.429% */
}
@media (min-width: 768px) {
	flex: 50%;

    &.flex-half {
        flex: 0 0 calc(50% - 12px);
    }

	&.flex-full {
		flex: 100%;
	}
}

${props => props.error ? `

    & div[class^="settings-v2__SettingsFormLabelContainer"],
    & div[class^="settings-v2__SettingsFormInputContainer"],
    & div[class^="settings-v2__SettingsSwitchContainer"]  {
        border-color: var(--Status-Cancelled, #BC362F);
        color:var(--Status-Cancelled, #BC362F);
        & div[class^="settings-v2__SettingsFormLabelLeftContainer"],
        & input, & textarea {
            color:var(--Status-Cancelled, #BC362F);
        }
        & svg path {
            fill: var(--Status-Cancelled, #BC362F);
        }
    }
    &::after {
        content: "${props.error}";
        display: block;
        width: 100%;
        position: relative;
        color:var(--Status-Cancelled, #BC362F);
        font-size: .75rem;
    }
    

 
`
        : null}
`

export const OptionalText = styled.span`
color: var(--Secondary-Smokey-Grey-1, #6B7270);
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 24px; /* 171.429% */
`

export const AddNewFieldButton = styled.button`
    display: flex;
    border: none;
    background-color: #FB2F2F;
    font-weight: 600;
    color: #F1F4F7;
    border-radius: 4px;
    padding: 8px;
    align-items: center;
    justify-content: center;
    width: 200px;
`

export const SettingsHeader = styled.div`
display: none;
padding: 12px 24px;
align-items: center;
justify-content: space-between;
gap: 16px;
align-self: stretch;
background: #FFF;
@media (min-width: 768px) {
    display: flex;
}
`

export const SettingsHeaderTextContainer = styled.div`
display: flex;
align-items: center;
gap: 16px;
flex: 1 0 0;
flex-wrap: wrap;
`

export const SettingsHeaderTextWrapper = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: flex-start;
gap: 8px;
flex: 1 0 0;
`

export const SettingsHeaderTextTitle = styled.div`
align-self: stretch;
color: var(--Secondary-Dark-Grey-1, #4B4F5E);
font-family: Inter;
font-size: 16px;
font-style: normal;
font-weight: 600;
line-height: 24px; /* 150% */
text-transform: capitalize;
`

export const SettingsHeaderTextBreadcrumbs = styled.div`
display: flex;
height: auto;
flex-wrap: wrap;
flex-direction: column;
justify-content: center;
align-self: stretch;

color: var(--Secondary-Smokey-Grey-1, #6B7270);
font-family: Inter;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 20px; /* 142.857% */
text-transform: capitalize;
`
export const SettingsHeaderMenuContainer = styled.div`
display: flex;
padding: 8px;
align-items: center;
gap: 8px;

border-radius: 4px;
background: var(--Neutral-Gray, #F1F4F7);

& div[class^="tooltip__TooltipWrapper"] {
    padding-left: 8px;
    padding-right: 8px;
}

& div.separator {
    background: #dfdfdf;
    width: 1px;
    height: 24px;
}

&.desktop-only {
    display: none;

    @media (min-width: 1024px) {
        display: flex;
    }
}
`

export const SettingsHeaderMenuItem = styled.div`
display: flex;
padding: 8px;
align-items: center;
gap: 8px;
cursor: pointer;

border-radius: 4px;
background: var(--Neutral-Gray, #F1F4F7);

& > * {
    color: var(--Secondary-Dark-Grey-1, #4B4F5E);
font-family: Poppins;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 24px; /* 150% */
}
`
export const SaveButtonWrapper = styled.div`
.mobile-view {
  display: none;
}
@media (max-width: 767px) {
  .desktop-view {
    display: none;
  }
  .mobile-view {
    display: flex;
    padding: none;
  }
}
`;
